module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/xheads2-fbb32e980cd8d1cbc8e5176536096823.jpg";